import { Link } from "gatsby";
import BlockText from "../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";
import Image from "gatsby-plugin-sanity-image";

export default function StandardSingleBlock({ pageBlock }) {
  const TextStyles = styled.div`
    a {
      ${tw`text-blue-500 cursor-pointer underline hover:text-blue-600`}
    }
    p {
      ${tw`text-sm md:text-lg mb-6`}
    }
  `;
  return (
    <div className="py-4 md:py-6">
      <div className="md:flex md:flex-wrap md:items-center">
        <div className="w-full md:w-5/12 md:mr-auto bg-white shadow-2xl rounded p-1 mb-6 md:mb-0">
          {pageBlock.image && pageBlock.image.asset && (
            <Image
              {...pageBlock.image}
              width={458}
              className="align-top"
              alt={pageBlock.image.alt || ``}
            />
          )}
          {pageBlock.videoID && (
            <div className="embed-responsive aspect-ratio-16/9 shadow-2xl">
              <iframe
                src={`https://www.youtube.com/embed/${pageBlock.videoID}?rel=0`}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen=""
                title={`YouTube Video`}
              />
            </div>
          )}
        </div>
        <div className="w-full md:w-6/12 md:mr-auto">
          <h2 className="text-blue-500 leading-tight font-bold tracking-tighter text-2xl md:text-3xl md:mb-3">
            {pageBlock.title}
          </h2>
          {pageBlock.subtitle && (
            <h3 className="text-xl md:text-2xl tracking-tight text-teal-600 mb-4 md:mb-0">
              {pageBlock.subtitle}
            </h3>
          )}
          <TextStyles>
            <BlockText blocks={pageBlock._rawBody} />
          </TextStyles>
          {pageBlock.buttonText &&
            pageBlock.link &&
            (pageBlock.link.href ? (
              <a
                className={`text-sm text-center md:text-base px-4 md:px-6 py-3 rounded transition ease-in-out duration-200 text-teal-900 inline-flex items-center bg-teal-500 uppercase tracking-tight font-bold hover:bg-blue-500 hover:text-blue-100`}
                href={pageBlock.link.href}
              >
                {pageBlock.buttonText}
              </a>
            ) : pageBlock.link &&
              pageBlock.link.reference &&
              pageBlock.link.reference.path ? (
              <a
                href={pageBlock.link.reference.path}
                className={`text-sm text-center md:text-base px-4 md:px-6 py-3 rounded transition ease-in-out duration-200 text-teal-900 inline-flex items-center bg-teal-500 uppercase tracking-tight font-bold hover:bg-blue-500 hover:text-blue-100`}
              >
                {pageBlock.buttonText}
              </a>
            ) : (
              "Reference page is missing its path"
            ))}
        </div>
      </div>
    </div>
  );
}
